import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "I Don't Know",
  "description": "",
  "published": "2012-01-24T00:00:00.000Z",
  "redirect_from": ["/blog/?p=3516"],
  "categories": "Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <lite-youtube {...{
      "videoid": "Na-KzVwu6es",
      "videostartat": "0"
    }}></lite-youtube>
    <p>{`I. Don't. Know.`}</p>
    <p>{`Three simple words and yet, almost impossible to say. As developers, as entrepreneurs, as `}<em parentName="p">{`men`}</em>{` we never want to admit we don't know. If you don't know, you are weak and an army of angry huns will come to steal your women, your business and your honor.`}</p>
    <p>{`And it often `}<em parentName="p">{`is`}</em>{` like that. As humans we tend to look up to that one guy (or gal) that Knows. Whether it's in a crisis, an emergency, or just deciding where to go for lunch. The person that Knows is inevitably the one that decides for the whole group. Saves everyone else from having to think.`}</p>
    <p>{`When founders don't know what the hell they're doing, people leave, investors say "maybe" and users aren't showing up. `}<em parentName="p">{`Especially`}</em>{` if they openly admit they don't know.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      